import { object, string, z } from 'zod';

import { DOMAIN_MATCHER, UUID_MATCHER } from '../common/matchers';
import { INVALID_DOMAIN, INVALID_UUID } from '../common/messages';
import type { TeamWithMembersDto } from './TeamDto';
import type { UserDto } from './UserDto';

export interface OrganizationDto {
  id: string;
  name: string;
  domain: string | null;
  createdAt: string;
  userCount: number;
  ciamProdPartyId: string | null;
  ciamUatPartyId: string | null;
  tppId: string | null;
}
export interface OrganizationDetailsDto extends OrganizationDto {
  users: UserDto[];
  teams: TeamWithMembersDto[];
}

export const organizationInputSchema = object({
  id: string().regex(UUID_MATCHER, INVALID_UUID).optional(),
  name: string().min(1),
  domain: string().regex(DOMAIN_MATCHER, INVALID_DOMAIN).nullable(),
  ciamProdPartyId: string().regex(UUID_MATCHER, INVALID_UUID).nullable(),
  ciamUatPartyId: string().regex(UUID_MATCHER, INVALID_UUID).nullable(),
  tppId: string().nullable(),
});

export type OrganizationInputDto = z.infer<typeof organizationInputSchema>;
